<template>
  <b-modal
    v-model="show_"
    :title="$t('tabs.settings.change_profile.title')"
    hide-footer
  >
    <form
      :data-vv-scope="formName"
      @submit.prevent="onSubmit"
    >
      <div class="form-group mb-4">
        <label for="updateProfile-input">
          {{ $t(`${tt}.avatar_image_url.label`) }}
        </label>
        <div class="d-flex form-control-static font-weight-semibold">
          <span class="btn mr-2 rounded-round btn-icon p-0">
            <img
              :onerror="`this.src = '${require('@/static/user__1_.png')}'`"
              :src="profileAvatarImage"
              width="32"
              height="32"
              class="rounded-circle"
              alt
            >
          </span>
          <button
            type="button"
            class="btn btn-light"
            @click="showAvatar = true"
          >
            <i class="icon-pencil6 mr-2" />
            {{ $t(`${tt}.avatar_image_url.btn_modal_open`) }}
          </button>
        </div>
        <avatar-box
          v-model="itemData.avatar_image_url"
          :show.sync="showAvatar"
        />
      </div>

      <div class="form-group mb-4">
        <label for="updateFirstName-input">
          {{ $t(`${tt}.name.label`) }}
        </label>
        <div class="row">
          <div class="col-6">
            <input
              id="updateFirstName-input"
              v-model="itemData.first_name"
              v-validate="'required'"
              name="first_name"
              :data-vv-as="$t(`${tt}.last_name.label`).toLowerCase()"
              :data-vv-scope="formName"
              type="text"
              class="form-control"
              :placeholder=" $t(`${tt}.first_name.placeholder`)"
              :class="{'is-invalid': errors.has(`${formName}.first_name`)}"
            >
          </div>
          <div class="col-6">
            <input
              id="updateLastName-input"
              v-model="itemData.last_name"
              v-validate="'required'"
              name="last_name"
              :data-vv-as="$t(`${tt}.last_name.label`).toLowerCase()"
              :data-vv-scope="formName"
              type="text"
              class="form-control"
              :placeholder=" $t(`${tt}.last_name.placeholder`)"
              :class="{'is-invalid': errors.has(`${formName}.last_name`)}"
            >
          </div>
        </div>
        <span
          v-if="errors.has(`${formName}.first_name`) || errors.has(`${formName}.last_name`)"
          class="invalid-feedback"
          v-html="errors.first(`${formName}.first_name`) || errors.first(`${formName}.last_name`)"
        />
      </div>

      <div class="form-group mb-4">
        <label for="updateTimeZone-input">
          {{ $t(`${tt}.timezone.label`) }}
        </label>
        <widget-field-timezone
          id="updateTimeZone-input"
          v-model="itemData.timezone"
          v-validate="'required'"
          name="timezone"
          :data-vv-as="$t(`${tt}.timezone.label`).toLowerCase()"
          :data-vv-scope="formName"
          type="text"
          :placeholder="$t(`${tt}.timezone.placeholder`)"
          :class="{'is-invalid': errors.has(`${formName}.timezone`)}"
        />
        <span
          v-if="errors.has(`${formName}.timezone`)"
          class="invalid-feedback"
          v-html="errors.first(`${formName}.timezone`)"
        />
      </div>

      <div class="text-right pt-5 mt-3">
        <b-button
          variant="link"
          @click="show_ = false"
        >
          {{ $t(`${tt}.button.close`) }}
        </b-button>
        <b-button
          type="submit"
          :disabled="submit"
          variant="primary"
          class="ml-1"
        >
          {{ $t(`${tt}.button.save`) }}
        </b-button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import ModalShowMixins from "../../../../mixins/ModalShowMixins";
import catchDispatch from "../../../../utils/catchDispatch";
import WidgetFieldTimezone from "../../../../components/Widget/WidgetFieldTimezone";
import AvatarBox from "./ChangeProfile/AvatarChangeProfileFormProfileTabComponents";
import FormMixins from "../../../../mixins/FormMixins";

export default {
  components: {
    AvatarBox,
    WidgetFieldTimezone,
  },
  mixins: [ModalShowMixins, FormMixins],
  data: () => ({
    tt: 'tabs.settings.change_profile.form',
    formName: 'change-profile',
    submit: false,
    showAvatar: false,
    itemData: {
      avatar_image_url: '',
      first_name: '',
      last_name: '',
      timezone: '',
    },
  }),
  computed: {
    ...mapGetters('auth', ['user']),
    profileAvatarImage() {
      return this.itemData.avatar_image_url || require('@/static/user__1_.png');
    },
  },
  watch: {
    show(show) {
      show && this.onShow()
    },
  },
  methods: {
    onShow() {
      Object.keys(this.itemData).map(key => {
        if (this.user[key]) this.itemData[key] = this.user[key];
      });
    },
    async onSubmit() {
      const valid = await this.onSubmitValid();
      if (!valid) return;

      axios
        .put(`/entities/api/v1/users/${this.user.id}`, {
          ...this.user,
          ...this.itemData,
        })
        .then(({data}) => {
          this.$store.commit('auth/SET_USER', data)
          this.show_ = false;
        })
        .catch(e => catchDispatch.call(this, e))
        .finally(() => this.submit = false);
    },
  },
}
</script>

<style scoped>

</style>
